var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraph = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 45.032H40.4142V35.3807H8.60443V5.83197H6.125V45.032ZM37.9456 42.5542H8.6152V37.8693H37.9456V42.5542ZM11.025 23.5411L12.8699 25.432L22.5467 16.1047L28.6034 21.8809L42.875 7.69974L40.9953 5.83197L28.5571 18.18L22.5351 12.4268L11.025 23.5411Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Graph.767f92df6bd2781ae597b815ab6e0b06.svg";